import React, { useContext, useEffect, useState } from 'react'
import useGet from '../customHooks/useGet';
import { Pagination, Space, Table } from 'antd';
import usePost from '../customHooks/usePost';
import { toast } from 'react-toastify';
import { MainLanguageContext } from '../context/MainLanguageContext';
import { InquriyData } from '../data/data';
import SkeletonEnquiries from './SkeletonEnquiries';
import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';

const Enquiries = () => {
      const { mainLanguage } = useContext(MainLanguageContext);
    const location = useLocation();
    const [datas, setDatas] = useState();
    const [tabIndex, setTabIndex] = useState("all")
    const [resget, apiMethodGet] = useGet();
const [searchValue, setSearchValue] = useState("")
    const [currentPage, setCurrentPage] = useState(1)

    const buildEnquiryUrl = (active = tabIndex, page = currentPage, search = searchValue) => {
        const trimmedSearch = search?.trim();
        const searchQuery = trimmedSearch ? `&search_query=${encodeURIComponent(trimmedSearch)}` : "";
        return `enquiries/list/${active}/${mainLanguage}/10?page=${page}${searchQuery}`;
    };

    const getSearchQueryFromUrl = () => {
        const params = new URLSearchParams(location.search);
        return params.get("search_query") || "";
    };

    useEffect(() => {
        if (!mainLanguage) {
            return;
        }
        const initialSearchValue = getSearchQueryFromUrl();
        setCurrentPage(1);
        setTabIndex("all");
        setSearchValue(initialSearchValue);
        apiMethodGet(buildEnquiryUrl("all", 1, initialSearchValue));
    }, [mainLanguage, location.search]);


    const onChange = (current, pageSize) => {
        setCurrentPage(current)
            apiMethodGet(buildEnquiryUrl(tabIndex, current, searchValue));

    };
    useEffect(() => {
        if (!resget.isLoading) {
            setDatas(resget?.data?.data)
        }

    }, [resget.data])



    useEffect(() => {
        if (resget.data) {
          console.log(resget?.data?.data)
            const updatedData = resget?.data?.data?.map((item, index) => ({
                ...item,
                key: `item-${index}`, // Add a unique key to each object
            }));
            setDatas(updatedData);
        }
    }, [resget.data]);


   const handleUpdate = (active) => {
    setCurrentPage(1)
    setTabIndex(active)
    apiMethodGet(buildEnquiryUrl(active, 1, searchValue));
   }


   
  let debounceTimer;
const debounce = (func, delay) => {
    return (...args) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };


  const executeApiCall = (e) => {console.log(e.target.value)
          setSearchValue(e.target.value)
    let formdata = new FormData();
    formdata.append('search_value', e.target.value);
    if ((e.target.value).trim()) {
        apiMethodGet(`enquiries/list/${tabIndex}/${mainLanguage}/12?page=1&search_query=${encodeURIComponent(e.target.value)}`, formdata);
    } else {
        apiMethodGet(`enquiries/list/${tabIndex}/${mainLanguage}/12?page=1`, formdata);

    }
  };

  const handleChange = debounce(executeApiCall, 1000)

   
    const columns = [
        {
          title: 'Id',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: 'Submit Time',
          render: (_, record) => (
            <>
             <div className='w-[200px]'>
            <b>{dayjs(record?.created_at).format('YYYY-MM-DD hh:mm A')}</b>
             </div>
            </>
          ),
        },
        
        {
          title: 'Client Name',
          render: (_, record) => (
            <>
             <Space size="middle">
             {record.client_name} {record?.client_last_name ?? ""}
           </Space>
            </>
          ),
        },
        {
          title: 'Client Data',
          render: (_, record) => (
            <>
             <div>
            <b>Email:</b><span>{record?.client_email}</span>
            <br />
            <b>PN:</b><span>{record?.client_phone}</span>
           </div>
            </>
          ),
        },
        {
          title: 'Comment',
          dataIndex: 'client_comments',
          key: 'client_comments',
          render: (_, record) => (
            <>
             <div className='w-[400px]'>
              {record.client_comments}
           </div>
            </>
          ),
        },
        {
          title: 'Comapny Name',
          dataIndex: 'company_name',
          key: 'company_name',
        },
        {
          title: ' Type',
          dataIndex: 'form_type',
          key: 'form_type',
        },
         {
          title: ' Data',
          render: (_, record) => (
            <>
             <Space size="middle">

           <ul>
           {record?.car_name && <li>Car Name : {record?.car_name}</li>}
            <li><b>Referer Page Slug:</b> {record?.referer_page_slug}</li>
            <br />
            <li><b>HTTP Referral Link:</b> {record?.http_referal_link ? record?.http_referal_link : "direct"}</li>
           </ul>
           </Space>
            </>
          ),
        },
       
         
       
      ];

  return (
    <div className='pr-10'>
        <h2 className='font-Mluvka text-[1.938rem] max-lg:text-[1.1rem] mb-2'>Enquiries</h2>
         <div className="bookingPage-left flex items-center justify-between gap-3 mb-3">
       
       
                       <ul className='list flex gap-6 mb-4 max-lg:flex-wrap'>
                           {
                               InquriyData.map((item, index) => {
                                   const { label, color,active } = item
                                   return (
                                       <li key={index} className={`font-MluvkaBold border-l-2 leading-[1] pl-2 cursor-pointer transition-all duration-300 ease-in-out   ${tabIndex === active ? "text-[#000] active" : "text-[#999]"}`} style={{ borderColor: color }} onClick={() => handleUpdate(active)}>{label}</li>
                                   )
                               })
                           }
                       </ul>
                        <div className="inputBox w-[16rem] max-lg:hidden mr-4">
            <input type="text"  onChange={handleChange} className='w-full border h-[2.8rem] rounded-full px-4 border-[#ddd] outline-none' placeholder='Search' />
        </div>
                   </div>
                   <div className='relative'>
                    {
                      resget.isLoading ? 
                      <SkeletonEnquiries />
                      :
                      <div>
                      <div className='bookingPagepagination overflow-auto'>
   
       <Table  scroll={{ x: 1300 }}  dataSource={datas} columns={columns} />
                      </div>
   
   
    { (datas?.length !== 0 || !resget?.error) && <div className='my-4'>
               <Pagination
                   onChange={onChange}
                   current={currentPage}
                   total={resget.data?.pagination?.total}
                   pageSize={10}
                    showSizeChanger={false}
                   />
           </div>}
           </div>
                    }
  
                </div>

    </div>
  )
}

export default Enquiries
